'use strict';

import Backbone from 'backbone';
import _ from 'underscore';
import mediator from '../../../js/mediator';
import {createEngineerMessageView} from '../../Engineer/EngineerMessageView';
import agentStateTemplateFactory from './agentStateTemplateFactory';

class VideoDeskBlock extends Backbone.View.extend({

  events: {
    'click .launchChat': 'launchChat',
    'click .launchCall': 'launchCall'
  }

}) {

  /**
   * @param options
   * @param options.globalSettings This includes translations and toggles that are used in the templates
   * @param options.shouldShowContactUs
   * @param options.isPreferentialBlock
   */
  initialize(options) {
    this.options = options;
    this.available = true;
    if (!this.options.shouldShowContactUs) {
      if (this.options.isPreferentialBlock) {
        mediator.on('videodesk:preferredAvailableModel', _.bind(this.modelUpdated, this));
        mediator.on('videodesk:noAgentsAvailable', _.bind(this.modelUpdated, this));
      } else {
        this.listenTo(this.model, 'change:isAgentAvailableToChat', this.render);
      }
    }
  }

  _makeVdkCall(callType = 'video') {
    var agentUid = this.model.get('uid');
    // then just make a call
    if (this.available) {
      window._vdk.call(callType, agentUid);
    }
  }

  launchChat(e) {
    e.preventDefault();
    this._makeVdkCall('text');
  }

  launchCall(e) {
    e.preventDefault();
    this._makeVdkCall('video');
  }

  modelUpdated(model) {
    this.model = model;
    this.render();
  }

  render() {
    if (this.options.shouldShowContactUs) {
      if (this.options.isPreferentialBlock) {
        this.template = agentStateTemplateFactory.getTemplateByState('unavailable');
      } else {
        this.template = agentStateTemplateFactory.getTemplateByState(this.options.templateName);
      }
    } else {
      if (this.options.isPreferentialBlock) {
        this.template = agentStateTemplateFactory.getTemplateByState(this.model.get('available_mode'));
      } else {
        this.template = agentStateTemplateFactory.getTemplateByState(this.options.templateName);
      }
    }
    var viewData = _.extend(
      {
        isChatPossible: this.model.get('is_text_capable'),
        isVideoPossible: this.model.get('is_video_capable') &&
          this.options.globalSettings.isUserVideoOk
      },
      this.model ? this.model.toJSON() : null,
      this.options
    );
    this.$el.html(this.template(viewData));

    // Enable the contact us email link
    if (this.options.isPreferentialBlock && !this.model.get('is_text_capable')) {
      createEngineerMessageView(this.$el.parent());
    }

    return this;
  }

}

module.exports = VideoDeskBlock;



// WEBPACK FOOTER //
// ./assets/components/VideoDesk/views/videoDeskBlock.js